import React from "react";
import ButtonList from "./ButtonList";
import VideoContainer from "./VideoContainer";

const Main = () => {
  return (
    <div>
      <ButtonList />
      <VideoContainer />
    </div>
  );
};

export default Main;
